import React, { useState, useEffect, useRef } from "react";
import { API_BASE_URL } from "../ApiConfig";
import style from "../../css/admin/Transaction.module.css";
import { getSecureToken } from "../ApisService/apiService";
import axios from "axios";

const LIMIT = 10;

const Transactionss = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();

  const fetchData = async (reset = false) => {
    try {
      setLoading(true);
      const { secrettoken, ts } = await getSecureToken();

      const response = await axios.get(
        `${API_BASE_URL}transaction/fetch_transaction.php`,
        {
          params: {
            search,
            status,
            page,
            limit: LIMIT,
          },
          headers: {
            "X-TOKEN": secrettoken,
            "X-TIMESTAMP": ts,
          },
          withCredentials: true,
        }
      );

      const result = response.data;
      const newData = Array.isArray(result.data) ? result.data : [];

      if (reset) {
        setData(newData);
      } else {
        setData((prev) => [...prev, ...newData]);
      }

      setHasMore(newData.length === LIMIT);
    } catch (error) {
      console.error("Failed to fetch data:", error?.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    fetchData(true);
  }, [search, status]);

  useEffect(() => {
    if (page > 1) fetchData();
  }, [page]);

  const lastRowRef = (node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        setPage((prev) => prev + 1);
      }
    });
    if (node) observer.current.observe(node);
  };

  return (
    <div className={style.container}>
      <div className={style.controls}>
        <input
          className={style.input}
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          className={style.select}
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="success">Success</option>
        </select>
      </div>

      <div className={style.tableWrapper}>
        <div className={style.tableHeader}>
          <div className={style.cell}>ID</div>
          <div className={style.cell}>Email</div>
          <div className={style.cell}>Mobile</div>
          <div className={style.cell}>Order ID</div>
          <div className={style.cell}>Payment ID</div>
          <div className={style.cell}>Amount</div>
          <div className={style.cell}>Status</div>
          <div className={style.cell}>Created</div>
        </div>
        {data.map((row, i) => {
          const isLast = i === data.length - 1;
          return (
            <div
              key={row.id}
              className={style.tableRow}
              ref={isLast ? lastRowRef : null}
            >
              <div className={style.cell}>{row.id}</div>
              <div className={style.cell}>{row.email}</div>
              <div className={style.cell}>{row.mobile_number}</div>
              <div className={style.cell}>{row.order_id}</div>
              <div className={style.cell}>{row.payment_id || "—"}</div>
              <div className={style.cell}>{row.amount}</div>
              <div
                className={`${style.cell} ${
                  row.status === "success" ? style.success : style.pending
                }`}
              >
                {row.status}
              </div>
              <div className={style.cell}>{row.created_at}</div>
            </div>
          );
        })}
      </div>

      {loading && <p style={{ textAlign: "center", margin: "1rem" }}>Loading...</p>}
    </div>
  );
};

export default Transactionss;
